<template>
  <div
    v-if="items && items.length > 0"
    :class="$isMobile ? 'article-qna-chips-mobile' : ''"
  >
    <div
      v-if="$isMobile"
      class="d-flex justify-end align-center mb-2"
    >
      <v-btn
        icon
        elevation="8"
        class="close-chip-btn"
        :style="{
          border: `2px solid ${COLORS.grainfoxAIButtonBorder}`,
          backgroundColor: 'white'
        }"
        @click="$emit('close')"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div
      v-else
      class="text-h6 font-weight-bold mb-3"
      :style="{ color: COLORS.grainfoxAIButton }"
    >
      Explore this report with Sinoa:
    </div>

    <div
      class="d-flex flex-column"
      :style="{ gap: '8px' }"
    >
      <v-card
        v-for="(item, index) in items"
        :key="index"
        role="button"
        tabindex="0"
        :aria-label="`Ask: ${item.question}`"
        elevation="8"
        class="px-4 py-3 ma-1 cursor-pointer rounded-xxl"
        :style="{
          border: `2px solid ${COLORS.grainfoxAIButtonBorder}`,
          backgroundColor: 'white'
        }"
        @click="handleQnaClick(item)"
        @keydown.enter="handleQnaClick(item)"
        @keydown.space.prevent="handleQnaClick(item)"
      >
        <span class="text-body-1 black--text text-decoration-none">
          {{ item.question }}
        </span>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import { datadogRum } from '@datadog/browser-rum';
import { COLORS } from '@/helpers/colors';

export default {
  name: 'ArticleQnaChips',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      COLORS,
      busy: false,
    };
  },

  computed: {
    ...mapState('chatbot', ['isChatUsageLoading']),
    ...mapState('app', ['isMimic']),
    ...mapGetters('chatbot', ['isLimitReached']),
  },

  methods: {
    ...mapMutations('chatbot', ['setShowPaywall', 'setGrainFoxAssistantDialogOpen', 'setShowFaqs']),
    ...mapActions('chatbot', ['showStoredAnswerWithStream', 'recordQnaInteraction', 'showStoredAnswer']),

    async handleQnaClick(item) {
      if (this.busy || this.isChatUsageLoading) {
        return;
      }

      // Hide the Frequent Questions carousel when user engages FAQ/QnA
      this.setShowFaqs(false);

      if (this.isLimitReached) {
        try {
          this.setGrainFoxAssistantDialogOpen(true);
          await this.showStoredAnswer({ ...item, question_type: 'qna' });
          // Do not record interaction when quota is exhausted to avoid counting toward usage
        } catch (error) {
          // ignore
        } finally {
          this.setShowPaywall(true);
        }
        return;
      }

      this.busy = true;

      try {
        this.setGrainFoxAssistantDialogOpen(true);

        this.showStoredAnswerWithStream({ ...item, question_type: 'qna' });

        await this.recordQnaInteraction(item);

        datadogRum.addAction('Sinoa: Click QnA Chip', {
          source: 'ArticleQnaChips',
          isMobile: this.$isMobile ?? null,
          questionLength: item.question?.length || 0,
          isMimic: this.isMimic,
        });
      } catch (error) {
        this.$snackbar?.error('Failed to process question. Please try again.');
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.article-qna-chips-mobile {
  position: fixed;
  bottom: 15%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 450px;
  z-index: 100;
}
</style>
